import CryptoJS from 'crypto-js';
import { SECRET_KEY } from '../Services/Constantes';
export const formatDate = (date) => {
  if (date !== undefined && date !== null) {

    const dayNumber = new Date(date).getDate();
    const month = new Date(date).getMonth() + 1;
    const year = new Date(date).getFullYear();
    return `${year}-${month < 10 ? `0${month}` : month}-${dayNumber < 10 ? `0${dayNumber}` : dayNumber}`;
  }
  return "1970-01-01";
};



/* export const handleEncrypt = (matriculePrincipal) => {
    let ciphertext =""
    if (matriculePrincipal) {
       ciphertext = CryptoJS.AES.encrypt(matriculePrincipal, SECRET_KEY).toString();
    }
    return ciphertext;
  };

 export const handleDecrypt = (matriculeAnonyme) => {
    let originalText =""
    if (matriculeAnonyme) {
      const bytes = CryptoJS.AES.decrypt(matriculeAnonyme, SECRET_KEY);
       originalText = bytes.toString(CryptoJS.enc.Utf8);
    
    }
      return originalText;
  }; */



/* 
const hashIdentifier = (identifier) => {
  return CryptoJS.HmacSHA256(identifier, SECRET_KEY).toString(CryptoJS.enc.Hex);
};

export const anonymizeIdentifier = (identifier) => {
  return hashIdentifier(identifier);
};

export const anonymizeName = (name) => {
   return 'XXXXXXX';
 }; */
const hashIdentifier = (identifier) => {
  return CryptoJS.HmacSHA256(identifier, SECRET_KEY).toString(CryptoJS.enc.Hex);
};

export const anonymizeIdentifier = (identifier) => {
  return hashIdentifier(identifier);
};

export const anonymizeName = (name) => {
  return 'XXXXXXX';
};





